import {ALLOWED_NON_TOKEN_COLORS} from './_constants';

export const background = {
  background: {
    scale: 'colors',
  },
  backgroundColor: {
    scale: 'colors',
    strictView: true,
    excludes: [
      'actionSecondaryBackground',
      'actionSecondaryBackgroundHover',
      'actionSecondaryBackgroundPressed',
      'uiSelectBackground',
      'uiSelectBackgroundHover',
    ],
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  backgroundSize: {
    scale: true,
  },
  backgroundPosition: {
    scale: true,
  },
  backgroundRepeat: {
    scale: true,
  },
  backgroundAttachment: {
    scale: true,
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Background = typeof background;
